import axios from "axios";
import { apiUrl } from "./config/settings";
import { getCookie, getFromLocalStorage, removeRandomChars } from "./config/functions";
import { setIsLogin } from "./store/userSettingsSlice";
import store from "./store";

const instance = axios.create({ baseURL: `${apiUrl}` });

instance.interceptors.request.use((param) => {
  const token = getCookie("authAnalytics");
  const sys = getCookie("sys");
  const biz = getFromLocalStorage("biz");
  param.headers.Authorization = `Bearer ${removeRandomChars(token, 4)}`;

  if (sys) {
    param.headers.Lab = sys;
  }

  if (biz) {
    param.headers.BizId = `${biz?.id}`;
    param.headers.BizPath = `${biz?.path}`;
  }

  return param;
});

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (err) => {
    if (err?.response?.status === 401) {
      store.dispatch(setIsLogin(false));
      window.history.pushState({}, "", `/Login`);
    }
    else {
      console.error("error", err);
      return err?.response;
    }
  }
);

export default instance;
